import { sortMasterDataValues } from './projectMasterDataUtils';

export const PARTNER_COMPANY_FILTER_ALL = 'all';
export const PARTNER_COMPANY_FILTER_NONE = '__none__';

export const normalizePartnerCompanyFilterValue = (value) => {
  const trimmed = String(value ?? '').trim();
  return trimmed || null;
};

export const derivePartnerCompanyFilterOptions = (companies, field) => {
  const values = new Set();
  let hasEmpty = false;

  companies.forEach((company) => {
    const normalizedValue = normalizePartnerCompanyFilterValue(company?.[field]);
    if (normalizedValue) {
      values.add(normalizedValue);
    } else {
      hasEmpty = true;
    }
  });

  const options = sortMasterDataValues([...values]);
  if (hasEmpty) {
    options.unshift(PARTNER_COMPANY_FILTER_NONE);
  }

  return options;
};

const matchesFieldFilter = (fieldValue, filterValue) => {
  if (filterValue === PARTNER_COMPANY_FILTER_ALL) {
    return true;
  }

  const normalizedFieldValue = normalizePartnerCompanyFilterValue(fieldValue);

  if (filterValue === PARTNER_COMPANY_FILTER_NONE) {
    return !normalizedFieldValue;
  }

  return normalizedFieldValue === filterValue;
};

const buildCompanySearchText = (company) => {
  const userSearchText = (company.users || [])
    .map((user) => [user.partnerName, user.email, user.manager].join(' '))
    .join(' ');

  return [
    company.csn,
    company.companyName,
    company.typeOfPartner,
    company.partnerAdoptionEngineer,
    company.tierStatus,
    company.serviceLevel,
    company.updatedBy,
    userSearchText,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
};

export const filterPartnerCompanies = (
  companies,
  {
    query = '',
    typeFilter = PARTNER_COMPANY_FILTER_ALL,
    paeFilter = PARTNER_COMPANY_FILTER_ALL,
    tierFilter = PARTNER_COMPANY_FILTER_ALL,
    serviceLevelFilter = PARTNER_COMPANY_FILTER_ALL,
  } = {},
) => {
  const queryValue = query.trim().toLowerCase();

  return companies.filter((company) => {
    const searchPass = !queryValue || buildCompanySearchText(company).includes(queryValue);
    const typePass = matchesFieldFilter(company.typeOfPartner, typeFilter);
    const paePass = matchesFieldFilter(company.partnerAdoptionEngineer, paeFilter);
    const tierPass = matchesFieldFilter(company.tierStatus, tierFilter);
    const serviceLevelPass = matchesFieldFilter(company.serviceLevel, serviceLevelFilter);

    return searchPass && typePass && paePass && tierPass && serviceLevelPass;
  });
};

export const hasActivePartnerCompanyFilters = ({
  query = '',
  typeFilter = PARTNER_COMPANY_FILTER_ALL,
  paeFilter = PARTNER_COMPANY_FILTER_ALL,
  tierFilter = PARTNER_COMPANY_FILTER_ALL,
  serviceLevelFilter = PARTNER_COMPANY_FILTER_ALL,
} = {}) => (
  Boolean(query.trim())
  || typeFilter !== PARTNER_COMPANY_FILTER_ALL
  || paeFilter !== PARTNER_COMPANY_FILTER_ALL
  || tierFilter !== PARTNER_COMPANY_FILTER_ALL
  || serviceLevelFilter !== PARTNER_COMPANY_FILTER_ALL
);

export const getPartnerCompanyFilterOptionLabel = (value) => {
  if (value === PARTNER_COMPANY_FILTER_NONE) {
    return 'Not set';
  }

  return value;
};

export const buildPartnerCompanyFilterDropdownOptions = (
  values = [],
  allLabel = 'All',
) => [
  { value: PARTNER_COMPANY_FILTER_ALL, label: allLabel },
  ...values.map((value) => ({
    value,
    label: getPartnerCompanyFilterOptionLabel(value),
  })),
];
